import { Loader, Stack, Text } from "@mantine/core";
import { Link, type ErrorComponentProps } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { isApiError } from "../../api/errors";
import { ErrorAlert } from "../../platform/ErrorAlert";
import { AuthSecondaryButton, AuthShell } from "../../ui/AuthShell";
import { NotInvitedNotice } from "./NotInvitedNotice";

function BackToSignIn({ label = "Back to sign-in" }: { label?: string }) {
  return (
    <AuthSecondaryButton component={Link} to="/sign-in" leftSection={<ArrowLeft size={20} />}>
      {label}
    </AuthSecondaryButton>
  );
}

export function GoogleFinishing() {
  return (
    <AuthShell title="Signing you in">
      <Stack align="center" gap="sm">
        <Loader size="sm" aria-hidden />
        <Text size="sm">Finishing sign-in with Google.</Text>
      </Stack>
    </AuthShell>
  );
}

/** Google came back without a code: the user cancelled, or the link was opened by hand. */
export function GoogleCancelled() {
  return (
    <AuthShell title="Google sign-in did not finish">
      <Text size="sm">Google did not sign you in. You can try again, or use a code by email.</Text>
      <BackToSignIn />
    </AuthShell>
  );
}

/**
 * The completion failed. There is no "Try again": Google's code is spent after one use, so the
 * only way forward is a new start from the sign-in page.
 */
export function GoogleCallbackError({ error }: ErrorComponentProps) {
  if (isApiError(error, "NOT_INVITED")) {
    return (
      <AuthShell title="You need an invitation">
        <NotInvitedNotice action={<BackToSignIn label="Use a different account" />} />
      </AuthShell>
    );
  }
  return (
    <AuthShell title="Google sign-in did not finish">
      <ErrorAlert error={error} />
      <BackToSignIn />
    </AuthShell>
  );
}
